export const codeLanguages: {
  value: string;
  label: string;
  decorate?: string;
}[] = [
  {
    value: 'asm',
    label: 'Assembly',
    decorate: 'asmatmel',
  },
  {
    value: 'bash',
    label: 'Bash',
  },
  {
    value: 'c',
    label: 'C',
  },
  {
    value: 'clojure',
    label: 'Clojure',
  },
  {
    value: 'cobol',
    label: 'COBOL',
  },
  {
    value: 'cpp',
    label: 'C++',
  },
  {
    value: 'csharp',
    label: 'C#',
  },
  {
    value: 'css',
    label: 'CSS',
  },
  {
    value: 'dart',
    label: 'Dart',
  },
  {
    value: 'dockerfile',
    label: 'Dockerfile',
    decorate: 'docker',
  },
  {
    value: 'elixir',
    label: 'Elixir',
  },
  {
    value: 'erlang',
    label: 'Erlang',
  },
  {
    value: 'fortran',
    label: 'Fortran',
  },
  {
    value: 'fsharp',
    label: 'F#',
  },
  {
    value: 'go',
    label: 'Go',
  },
  {
    value: 'graphql',
    label: 'GraphQL',
  },
  {
    value: 'groovy',
    label: 'Groovy',
  },
  {
    value: 'haskell',
    label: 'Haskell',
  },
  {
    value: 'haxe',
    label: 'Haxe',
  },
  {
    value: 'html',
    label: 'HTML',
  },
  {
    value: 'ini',
    label: 'INI',
  },
  {
    value: 'java',
    label: 'Java',
  },
  {
    value: 'javascript',
    label: 'JavaScript',
  },
  {
    value: 'jsx',
    label: 'JavaScript (React)',
  },
  {
    value: 'json',
    label: 'JSON',
  },
  {
    value: 'julia',
    label: 'Julia',
  },
  {
    value: 'kotlin',
    label: 'Kotlin',
  },
  {
    value: 'latex',
    label: 'LaTeX',
  },
  {
    value: 'lua',
    label: 'Lua',
  },
  {
    value: 'markdown',
    label: 'Markdown',
  },
  {
    value: 'matlab',
    label: 'MATLAB',
  },
  {
    value: 'makefile',
    label: 'Makefile',
  },
  {
    value: 'objectivec',
    label: 'Objective-C',
  },
  {
    value: 'perl',
    label: 'Perl',
  },
  {
    value: 'php',
    label: 'PHP',
  },
  {
    value: 'plaintext',
    label: 'Plain text',
  },
  {
    value: 'powershell',
    label: 'PowerShell',
  },
  {
    value: 'python',
    label: 'Python',
  },
  {
    value: 'r',
    label: 'R',
  },
  {
    value: 'ruby',
    label: 'Ruby',
  },
  {
    value: 'rust',
    label: 'Rust',
  },
  {
    value: 'sas',
    label: 'SAS',
  },
  {
    value: 'scala',
    label: 'Scala',
  },
  {
    value: 'scheme',
    label: 'Scheme',
  },
  {
    value: 'shell',
    label: 'Shell',
  },
  {
    value: 'sql',
    label: 'SQL',
  },
  {
    value: 'stata',
    label: 'Stata',
  },
  {
    value: 'swift',
    label: 'Swift',
  },
  {
    value: 'typescript',
    label: 'TypeScript',
    decorate: 'ts',
  },
  {
    value: 'tsx',
    label: 'TypeScript (React)',
  },
  {
    value: 'vbnet',
    label: 'VB.NET',
  },
  {
    value: 'xml',
    label: 'XML',
  },
  {
    value: 'yaml',
    label: 'YAML',
    decorate: 'yml',
  },
];
